import { Field, Formik, Form } from 'formik';
import React, { useRef, useState } from 'react';
import * as Yup from 'yup';
import LabelWithTick from '../../UI/LabelWithTick/helper';
import FormError from '../../UI/FormError';
import close from '../../../assets/images/close_white.svg';
import './../NewsSubmissionForm/styles.scss';
import { createMarketingCategory } from 'store/actions/MarketingCategoryActions';
import { createMarketingSource } from 'store/actions/MarketingSourceActions';
import { connect } from 'react-redux';
import FileInput from 'components/AccountSettings/InventoryManagement/resolveDropDown/CustomComponents/FileInput/FileInput';
import { ALLOWED_NEWS_IMAGE_TYPES } from '../constants';

const SourceCategoryForm = ({
  closedText = 'Cancel',
  submitText = 'Submit',
  _handleClose,
  setSubmitSuccess,
  isSubmitSuccessful,
  footerClass = '',
  requirementFormClass = '',
  formRef,
  formType = 'source',
  setOpenSource,
  createMarketingCategory,
  createMarketingSource,
  setIsUpdated,
  handleItemAdd,
}) => {
  const formContentRef = useRef();
  const [toastVisible, setToastVisible] = useState(false);

  const FORM_INITIAL_STATE =
    formType === 'category'
      ? { category: '' }
      : formType === 'source'
      ? {
          source: '',
          websiteLink: '',
          image: null,
        }
      : {};

  const ValidationSchema =
    formType === 'category'
      ? Yup.object().shape({
          category: Yup.string().required('Category is required'),
        })
      : Yup.object().shape({
          source: Yup.string().required('Source is required'),
          websiteLink: Yup.string()
            .matches(/^https?:\/\/(www\.)?([a-z0-9-]+\.)+[a-z]{2,}(\/.*)?$/i, 'URL must be valid')
            .required('Website link is required'),
          image: Yup.mixed().nullable().required('Please attach an image'),
        });
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      if (formType === 'category') {
        await createMarketingCategory(values);
        handleItemAdd('Category Added Successfully');
        setOpenSource('');
      } else if (formType === 'source') {
        values.image = values.image.fileUrl;
        await createMarketingSource(values);
        setOpenSource('');
        handleItemAdd('Source Added Successfully');
      }
      setIsUpdated(true);
    } catch (err) {
      console.error('Form submission error:', err);
      setOpenSource('');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCloseModal = () => {
    setOpenSource('');
  };
  return (
    <>
      {!isSubmitSuccessful ? (
        <Formik
          innerRef={formRef}
          initialValues={FORM_INITIAL_STATE}
          validationSchema={ValidationSchema}
          onSubmit={handleSubmit}>
          {({ errors, touched, setFieldValue, values }) => {
            const formValidation =
              Object.keys(errors).length === 0 &&
              Object.values(values).every((v) => v !== '' && v !== null);

            return (
              <Form className={requirementFormClass + ' requirementContainer'}>
                <div className="requirementForm">
                  <div className="formContent sourceFormContent" ref={formContentRef}>
                    {formType === 'category' && (
                      <>
                        <div className="news__modal__header">
                          <h1>Add Category</h1>
                          <img
                            src={close}
                            className="modal__close"
                            alt="Close"
                            onClick={handleCloseModal}
                          />
                        </div>
                        <div className="field">
                          <LabelWithTick
                            label="Category"
                            withValidation={true}
                            isValid={values.category && !errors.category}
                            labelClass="label"
                          />
                          <Field type="text" name="category" placeholder="Enter news category" />
                          {touched.category && errors.category && (
                            <FormError error={errors.category} errorClass="field-error" />
                          )}
                        </div>
                        <div className={'flex-center submit__container ' + footerClass}>
                          <button className="close-btn" type="button" onClick={handleCloseModal}>
                            {closedText}
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary buttonWidth"
                            disabled={!formValidation}>
                            {submitText}
                          </button>
                        </div>
                      </>
                    )}

                    {formType === 'source' && (
                      <>
                        <div className="news__modal__header">
                          <h1>Add Source</h1>
                          <img
                            src={close}
                            className="modal__close"
                            alt="Close"
                            onClick={handleCloseModal}
                          />
                        </div>
                        <div className="field">
                          <LabelWithTick
                            label="Source"
                            withValidation={true}
                            isValid={values.source && !errors.source}
                            labelClass="label"
                          />
                          <Field type="text" name="source" placeholder="Enter news source" />
                          {touched.source && errors.source && (
                            <FormError error={errors.source} errorClass="field-error" />
                          )}
                        </div>

                        <div className="field">
                          <LabelWithTick
                            label="Website Link"
                            withValidation={true}
                            isValid={values.websiteLink && !errors.websiteLink}
                            labelClass="label"
                          />
                          <Field
                            type="text"
                            name="websiteLink"
                            placeholder="https://www.example.com"
                          />
                          {touched.websiteLink && errors.websiteLink && (
                            <FormError error={errors.websiteLink} errorClass="field-error" />
                          )}
                        </div>

                        <div className="file-input-wrapper">
                          <FileInput
                            uploadButtonName="Attach Image"
                            name="image"
                            label="Attach Image"
                            isRequired={true}
                            resetUpload={!values['image']}
                            acceptFileType={ALLOWED_NEWS_IMAGE_TYPES}
                            isFullWidth={true}
                          />
                        </div>

                        <div className={'flex-center submit__container ' + footerClass}>
                          <button className="close-btn" type="button" onClick={handleCloseModal}>
                            {closedText}
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary buttonWidth"
                            disabled={!formValidation}>
                            {submitText}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => ({
  marketingCategories: state.marketingCategories,
  marketingSources: state.marketingSources,
});

const mapDispatchToProps = (dispatch) => ({
  createMarketingSource: (data) => dispatch(createMarketingSource(data)),
  createMarketingCategory: (data) => dispatch(createMarketingCategory(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SourceCategoryForm);
